import React from 'react'
import Registration from './Registration'

const ClinicRegistration = () => {
  return (
    <Registration/>
  )
}

export default ClinicRegistration